import { render, staticRenderFns } from "./detail.modal.vue?vue&type=template&id=0fe66e14&"
import script from "./detail.modal.vue?vue&type=script&lang=js&"
export * from "./detail.modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports